<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="10">
          <a-col></a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Booking #">
              <a-input v-model="queryParam.query" placeholder="" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Tour Code">
              <a-input v-model="queryParam.tourcode" placeholder="" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Invoice #">
              <a-input v-model="queryParam.invoice" placeholder="" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Sabre">
              <a-input v-model="queryParam.sabre" placeholder="" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Name">
              <a-input v-model="queryParam.fullName" placeholder="Last Name / First Name" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Dept.">
              <a-select v-model="queryParam.dept" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="sigusa">sigusa</a-select-option>
                <a-select-option value="supus">supusa</a-select-option>
                <a-select-option value="sigcan">sigcan</a-select-option>
                <a-select-option value="supcan">supcan</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Status">
              <a-select v-model="queryParam.status" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="0">New Booking</a-select-option>
                <a-select-option value="1">Deposited</a-select-option>
                <a-select-option value="2">Invoiced</a-select-option>
                <a-select-option value="3">Travel Doc</a-select-option>
                <a-select-option value="4">Guide's greeting</a-select-option>
                <a-select-option value="-1">Cancelled</a-select-option>
                <a-select-option value="5">Completed</a-select-option>
                <a-select-option value="W">Waiting</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="Booking period">
              <a-range-picker format="MM/DD/YYYY"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Assigned Sales">
              <a-select v-model="queryParam.assigned" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="22">Eric Yim</a-select-option>
                <a-select-option value="35">Q Chiu</a-select-option>
                <a-select-option value="46">Rainie Zhu</a-select-option>
                <a-select-option value="48">Alan Cheng</a-select-option>
                <a-select-option value="36">Sylvia Li</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Agency">
              <a-input v-model="queryParam.aAgency" placeholder="" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = { query: '', registerSite: '' }">Clear</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="default"
      rowKey="id"
      showQuickJumper
      :columns="columns"
      :data="loadData"
    >
      <span slot="bookingNumber" slot-scope="text, record">
        <a class="link-btn" @click="handleEdit(record)" :disabled="!$auth('DEMO')">{{text}}</a>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault(record)">
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;">Confirmation</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;">Modified</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;">Modified</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;">Deposit</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import moment from 'moment'
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import BookingApi from '@/api/obs/api-obs-booking'

export default {
  name: 'BookList',
  components: {
    STable
  },
  props: {
  },
  data () {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { query: '', registerSite: '' },
      // 表头
      columns: [
        {
          title: 'Booking #',
          dataIndex: 'bookingNumber',
          scopedSlots: { customRender: 'bookingNumber' }
        },
        {
          title: 'Booking Date',
          dataIndex: 'bookingTime'
        },
        {
          title: 'Name',
          dataIndex: 'tourName'
        },
        {
          title: 'tourCode',
          dataIndex: 'tourCode'
        },
        {
          title: 'Dept.',
          dataIndex: 'department',
        },
        {
          title: 'Agency',
          dataIndex: 'agencyName',
        },
        {
          title: 'Sales Rep.',
          dataIndex: 'repSalesName',
        },
        {
          title: 'Status',
          dataIndex: 'bookingStatus',
        },
        {
          title: 'PDF Document',
          dataIndex: 'PDFDocument',
          customRender: () => {
            return 'Confirmation'
          }
        },
        {
          title: '',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return BookingApi.query(Object.assign(parameter, this.queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
  },
  methods: {
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    handleOk () {
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
